export default __webpack_public_path__ + "static/bncff-web-site-5-mobile-5c76b9237d912d10619cf04c0feb5c23.jpg";